<div class="alert-dialog ups-dialog">
    <h2 mat-dialog-title *ngIf="title">{{ title }}</h2>
    <mat-dialog-content>
        <div class="dialog-content {{ messageClass }}" [innerHtml]="message"></div>
    </mat-dialog-content>
    
    <!-- <mat-dialog-actions>
        <button mat-raised-button color="primary" mat-dialog-close>OK</button>
    </mat-dialog-actions> -->

    <button type="button" mat-raised-button class="icon-button close-button" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
